var _g, _g2, _g3, _text, _text2, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDualHorizontalReceipt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8_233_1",
    "data-name": "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8 233 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 301,
    height: 180,
    viewBox: "0 0 301 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9577\\u65B9\\u5F62_1481",
    "data-name": "\\u9577\\u65B9\\u5F62 1481",
    fill: "#f0f0f0",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 301,
    height: 180,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 300,
    height: 179,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u9577\\u65B9\\u5F62_1482",
    "data-name": "\\u9577\\u65B9\\u5F62 1482",
    transform: "translate(28 18)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 141,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 140,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u9577\\u65B9\\u5F62_1484",
    "data-name": "\\u9577\\u65B9\\u5F62 1484",
    transform: "translate(176 18)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 141,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 140,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "\\u9818\\u53CE\\u66F81",
    transform: "translate(43 81)",
    fill: "#707070",
    fontSize: 16,
    fontFamily: "HiraginoSans-W6, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "\u9818\u53CE\u66F81"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "\\u9818\\u53CE\\u66F82",
    transform: "translate(191 81)",
    fill: "#707070",
    fontSize: 16,
    fontFamily: "HiraginoSans-W6, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "\u9818\u53CE\u66F82"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_354",
    "data-name": "\\u7DDA 354",
    y2: 141,
    transform: "translate(147.5 18)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    strokeDasharray: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDualHorizontalReceipt);
export default __webpack_public_path__ + "static/media/dual_horizontal_receipt.ede7bb7b4adfa9c36ae2fe1ff5891c1d.svg";
export { ForwardRef as ReactComponent };